import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
  useMsalAuthentication,
} from "@azure/msal-react";
import { loginRequest } from "./components/auth/authConfig";
import { AuthProvider } from "./context/AuthContext";
import AppRoutes from "./AppRoutes";
import FullScreenLoader from "./components/common/FullScreenLoader";
import { registerLoadingHandler } from "./utils/axiosConfig";

const App = () => {
  const { accounts, instance } = useMsal();
  const [accessToken, setAccessToken] = useState(null);
  const [loading, setLoading] = useState(false);

  // Hook que maneja automáticamente login interactivo si no hay sesión
  useMsalAuthentication("redirect", loginRequest);

  useEffect(() => {
    registerLoadingHandler(setLoading); //  registra el manejador global del loader

    //console.log("Cuentas en contexto MSAL:", accounts);
    if (accounts.length > 0) {
      // Intentar obtener token silencioso
      instance
        .acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        })
        .then((response) => {
          //console.log("AccessToken:", response.accessToken);
          setAccessToken(response.accessToken);

        })
        .catch((err) => {
          console.warn("Silent token falló, fallback a redirect", err);
          instance.acquireTokenRedirect(loginRequest);
        });
    }
  }, [accounts, instance]);

  return (
    <AuthProvider>
      <Router>
        {loading && <FullScreenLoader />}

        <AuthenticatedTemplate>
            <AppRoutes />
        </AuthenticatedTemplate>

        <UnauthenticatedTemplate>
          <div>Redirigiendo a Entra ID para iniciar sesión...</div>
        </UnauthenticatedTemplate>
      </Router>
    </AuthProvider>
  );
};

export default App;


/** import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import AppRoutes from "./AppRoutes";

const App = () => (
  <AuthProvider>
    <Router>
      <AppRoutes />
    </Router>
  </AuthProvider>
);

export default App;

/** import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Login from './components/auth/Login';
import Dashboard from './components/dashboard/index';
import OrdenesExt from './components/dashboard/Dashboard';
import Layout from './components/Layout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Usuarios from './components/usuarios/Usuarios';
import Modal from './components/common/Modal';
import useSessionTimeout from './hooks/useSessionTimeout';
import Procesos from './components/procesos';
import SalesOrders from './components/salesorders';
import MaximosProducto from './components/maximos/index';
import Results from './components/results/index';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useApi } from './hooks/useApi';
import Unauthorized from "./components/permisos/Unauthorized";

const AppRoutes = () => {
  const { user, token, logout, setToken } = useAuth();
  const { get, post, loading, error } = useApi();

  

    const refreshToken = async () => {
      try {
        const data = await post('refreshToken');      
        setToken(data.token);
        localStorage.setItem('token', data.token);
        return data.token;
      } catch (error) {
        console.error('Error al refrescar token', error);
        logout(); // o lo que corresponda si el refresh falla
      }
    };

  

    //if (!response.ok) throw new Error('No se pudo renovar token');
    // const data = await response.json();
   // setToken(data.token);
   // localStorage.setItem('token', data.token);
    //return data.token;
  //};

  // Hook para manejar expiración de sesión y renovación
  const { showRenewModal, renewSession, logout: sessionLogout, setShowRenewModal } = useSessionTimeout(refreshToken);

  const handleLogout = () => {
    setShowRenewModal(false);
    sessionLogout();
  };

  const handleRenewSession = async () => {
      await renewSession();
      setShowRenewModal(false);
  };

  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={user ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ordenes-externas"
          element={
            <ProtectedRoute>
              <Layout>
                <OrdenesExt />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/usuarios"
          element={
            <ProtectedRoute>
              <Layout>
                <Usuarios />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/configuracion"
          element={
            <ProtectedRoute>
              <Layout>
                <Procesos />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/pedidos-automaticos"
          element={
            <ProtectedRoute>
              <Layout>
                <SalesOrders />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/maximos-de-productos"
          element={
            <ProtectedRoute>
              <Layout>
                <MaximosProducto />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/resultados-sap"
          element={
            <ProtectedRoute>
              <Layout>
                <Results />
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>

      <Modal show={showRenewModal} title="Sesión a punto de expirar" onClose={handleLogout}>
        <p className="mb-4 text-gray-700">Tu sesión está a punto de expirar. ¿Deseas renovarla?</p>
        <div className="flex justify-end gap-2">
          <button
            className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded"
            onClick={handleLogout}
          >
            Cerrar sesión
          </button>
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
            onClick={handleRenewSession}
          >
            Renovar sesión
          </button>
        </div>
      </Modal>
      <ToastContainer position="top-right" autoClose={3000} />

    </>
  );
};

const App = () => (
  <Router>
    <AppRoutes />
  </Router>
);

export default App;
*/ 